/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cards_Activity_Range_Dropdown_DescriptionInputs */



/**
* | output |
* | --- |
* | "For volume, transactions & users" |
*
* @param {Cards_Activity_Range_Dropdown_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cards_activity_range_dropdown_description = /** @type {((inputs?: Cards_Activity_Range_Dropdown_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cards_Activity_Range_Dropdown_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("For volume, transactions & users")
});